// lib
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// src
import Table from "containers/plannings/table/Table";

const LightHome = ({
  // data props
  needsRefresh,
  // action props
  fetchEnableds,
}) => {
  const [doProceed, setDoProceed] = useState(false);
  useEffect(() => setDoProceed(true), []);

  // hard refresh may be sent from global state (for instance at startup
  // or after login or when app becomes idle and active again)
  if (doProceed && needsRefresh) {
    fetchEnableds();
    setDoProceed(false);
  }

  return <Table />;
};

LightHome.propTypes = {
  // data props
  needsRefresh: PropTypes.bool.isRequired,
  // action props
  fetchEnableds: PropTypes.func.isRequired,
};

export default LightHome;
